export const HOME_PAGE_ANCHORS = {
    about: "intro-section",
    work: "professional-experience-section",
    projects: "projects-section",
};
